(function () {
  'use strict';

  /* @ngdoc object
   * @name events.vehicles.list
   * @description
   *
   */
  angular
    .module('events.vehicles.list', [
      'ui.router'
    ]);
}());
